import { render, staticRenderFns } from "./NewSubDocForm.vue?vue&type=template&id=4c672211"
import script from "./NewSubDocForm.vue?vue&type=script&lang=ts"
export * from "./NewSubDocForm.vue?vue&type=script&lang=ts"
import style0 from "./NewSubDocForm.vue?vue&type=style&index=0&id=4c672211&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports